<template>
	<div class="content-box-wrapper" v-if="course.title">
		<div class="content-box-header">
			<h2 class="content-box-header__headline text-17">
				{{ course.title }}
			</h2>
		</div>
		<div class="content-box-padding" v-html="course.intro_text"></div>
	</div>
</template>
<script>
export default {
	name: "IntroScreen",
	props: [],
	components: {},
	computed: {
		course() {
			return this.$store.state.course;
		}
	},
	methods: {},
	mounted() {}
};
</script>